const apiUrls = {
  WP_GET: "https://seascape-edition.com/seascape/wp-json/get/",
};

export default apiUrls;
